export default function (state = {
  isFetching: false,
  didInvalidate: false,
}, action) {
  switch (action.type) {
    default:
      return state;
  }
}
